import React from "react";
import "./style.scss";
import Icons from "../../../components/Icons";

export default ({onClick}) => {
    if (!onClick) {
        return null;
    }

    return (
        <div className={`player-banner--button-close`} onClick={onClick}>
            <Icons name="close" />
        </div>
    );
}
